<template>
  <collapse-default :id="`endereco-${ordem}`"
                    :collapse-visible="collapseVisible"
                    :condition="!!endereco && (!!endereco.logradouro || !!endereco.uf && !!endereco.cidade)">
    <template v-slot:header>
      Endereco  {{ !endereco || !endereco.logradouro || (!endereco.uf && !endereco.cidade && !endereco.exterior) ? ' - Nenhum informado' : '' }}
    </template>

    <template v-slot:content>
      <div v-if="!!endereco.logradouro || !!endereco.uf && !!endereco.cidade">
        <div class="resumo-show_header--blue mt-2">
          {{ (endereco.logradouro || (endereco.uf && endereco.cidade) || (endereco.exterior)) || 'Não informado' }}
        </div>
        <div class="pl-4 pl-4 row">
          <div class="col-10">
            <div class="row">
              <div v-if="!endereco.exterior"
                   class="col">
                <label class="resumo-show_header--label">CEP</label>
                <div class="resumo-show_header--sublabel">
                  {{ endereco.cep || 'Não informado' }}
                </div>
              </div>
              <div v-if="!endereco.exterior"
                   class="col">
                <label class="resumo-show_header--label">Número</label>
                <div class="resumo-show_header--sublabel">
                  {{ endereco.numero || 'Não informado' }}
                </div>
              </div>
              <div v-if="!endereco.exterior"
                   class="col">
                <label class="resumo-show_header--label">Complemento</label>
                <div class="resumo-show_header--sublabel">
                  {{ endereco.complemento || 'Não informado' }}
                </div>
              </div>
              <div v-if="!endereco.exterior"
                   class="col">
                <label class="resumo-show_header--label">Bairro</label>
                <div class="resumo-show_header--sublabel">
                  {{ endereco.bairro || 'Não informado' }}
                </div>
              </div>
              <div v-if="!endereco.exterior"
                   class="col">
                <label class="resumo-show_header--label">Cidade</label>
                <div class="resumo-show_header--sublabel">
                  {{ endereco.cidade || 'Não informado' }}
                </div>
              </div>
              <div v-if="!endereco.exterior"
                   class="col">
                <label class="resumo-show_header--label">UF</label>
                <div class="resumo-show_header--sublabel">
                  {{ endereco.uf || 'Não informado' }}
                </div>
              </div>
              <div v-if="endereco.exterior"
                   class="col">
                <label class="resumo-show_header--label">Pais</label>
                <div class="resumo-show_header--sublabel">
                  {{ endereco.codigo_pais || 'Não informado' | getPaisById }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </collapse-default>
</template>

<script>
  import CollapseDefault from "./CollapseDefault"

  /* filters */

  export default {
    name: "EnderecoCollapse",
    components: {
      CollapseDefault
    },
    props: {
      endereco: {
        type: Object,
        default: () => ({})
      },
      collapseVisible: {
        type: Boolean,
        default: false
      },
      ordem: {
        type: Number,
        default: 1
      }
    },
  }
</script>

<style scoped>

</style>
